export default "__VITE_ASSET__56a4ea94__"